export default {"src":"/_next/static/media/offeneDeals.a3167e21.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};